import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import Phonetic from "./Phonetic";
import Meaning from "./Meaning";
import "./Result.css";

export default function Result(props) {
  console.log(props.response);
  if (props.response) {
    return (
      <div className="Result">
        <div className="keyword mt-5 ps-5">
          <h2 className="text-capitalize">{props.response.word}</h2>

          {props.response.phonetics?.map(function (phonetic, index) {
            return (
              <div key={index}>
                <Phonetic phonetic={phonetic} />
              </div>
            );
          })}
        </div>
        <div className="meaning mt-5 ps-5">
          {props.response.meanings?.map(function (meaning, index) {
            return (
              <section key={index}>
                <Meaning meaning={meaning} />
              </section>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
